<script setup>

import {computed} from "vue";

const props = defineProps({
  type: String,
  cardState: Object
})
const calloutClass = computed(() => {
  return `standard-preset-callout ${props.type}`
})
const open = computed(() => {
  return (props.cardState.expanded === props.type)
})
</script>

<template>
  <div :class="calloutClass" v-if="open">
    <slot/>
  </div>
</template>
